import React from 'react';
import { Content, Row, Col, Title, Text, Pagination, Image } from 'components';
import { Button, Empty } from 'antd';
import { encrypt } from 'utils/Crypto';

const TAP = [
  {
    label: '전체',
    value: 'ALL',
  },
  {
    label: '좋아요',
    value: 'LIKE',
  },
  {
    label: '리빙',
    value: 'LIVING',
  },
  {
    label: '잡화/도구',
    value: 'TOOL',
  },
];

const PAGE_COUNT = 5;
const PAGE_SIZE = 12;

const brands = [
  {
    shop_information_id: '1',
    shop_information_name: 'JMCOFFEE',
    src: 'https://via.placeholder.com/300x200?text=JMCOFFEE',
    status: 'ALL',
  },
  {
    shop_information_id: '2',
    shop_information_name: 'COMPOSE COFFEE',
    src: 'https://via.placeholder.com/300x200?text=COMPOSE',
    status: 'ING',
  },
  {
    shop_information_id: '3',
    shop_information_name: 'NESPRESSO',
    src: 'https://via.placeholder.com/300x200?text=NESPRESSO',
    status: 'PREV',
  },
  {
    shop_information_id: '4',
    shop_information_name: 'G7',
    src: 'https://via.placeholder.com/300x200?text=G7',
    status: 'END',
  },
  {
    shop_information_id: '5',
    shop_information_name: 'JMCOFFEE',
    src: 'https://via.placeholder.com/300x200?text=JMCOFFEE',
    status: 'ALL',
  },
  {
    shop_information_id: '6',
    shop_information_name: 'COMPOSE COFFEE',
    src: 'https://via.placeholder.com/300x200?text=COMPOSE',
    status: 'ING',
  },
  {
    shop_information_id: '7',
    shop_information_name: 'NESPRESSO',
    src: 'https://via.placeholder.com/300x200?text=NESPRESSO',
    status: 'PREV',
  },
  {
    shop_information_id: '8',
    shop_information_name: 'G7',
    src: 'https://via.placeholder.com/300x200?text=G7',
    status: 'END',
  },
  {
    shop_information_id: '9',
    shop_information_name: 'JMCOFFEE',
    src: 'https://via.placeholder.com/300x200?text=JMCOFFEE',
    status: 'ALL',
  },
  {
    shop_information_id: '10',
    shop_information_name: 'COMPOSE COFFEE',
    src: 'https://via.placeholder.com/300x200?text=COMPOSE',
    status: 'ING',
  },
  {
    shop_information_id: '11',
    shop_information_name: 'NESPRESSO',
    src: 'https://via.placeholder.com/300x200?text=NESPRESSO',
    status: 'PREV',
  },
  {
    shop_information_id: '12',
    shop_information_name: 'G7',
    src: 'https://via.placeholder.com/300x200?text=G7',
    status: 'END',
  },
];

const BrandPresenter = (props) => {
  /* ===== Props ===== */
  const { navigate, screenSize, brand } = props;

  /* ===== State ==== */
  const [brandList, setBrandList] = React.useState([...brand]);
  // const [activeButton, setActiveButton] = React.useState('ALL');
  const [currentPage, setCurrentPage] = React.useState(1);

  // const handleFilter = (value) => {
  //   setActiveButton(value);
  //   if (value === 'ALL') {
  //     setBrandList(brands); // 전체 보기
  //   } else {
  //     setBrandList(brands.filter((brand) => brand.status === value));
  //   }
  // };

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 64 : screenSize >= 500 ? 40 : 28,
      fontFamily: `"Dela Gothic One", sans-serif`,
      fontWeight: 400,
      fontStyle: 'normal',
      textTransform: 'capitalize',
    },
    button: {
      padding: '10px 29px',
      backgroundColor: 'transparent',
      border: '1px solid #ddd',
      color: 'var(--black-color)',
    },
    activeButton: {
      padding: '10px 29px',
      backgroundColor: 'var(--black-color)',
      color: 'white',
    },
    brandImage: {
      width: '100%',
      height: 'auto',
      aspectRatio: '367 / 237',
      objectFit: 'cover',
      display: 'flex',
    },
    brandItem: {
      boxSizing: 'border-box',
      cursor: 'pointer',
    },
    brandTitle: {
      fontSize: screenSize >= 768 ? 24 : screenSize >= 500 ? 20 : 15,
      fontWeight: 700,
      margin: screenSize >= 500 ? '24px 0 12px' : '15px 0 10px',
      cursor: 'pointer',
      webkitLineClamp: 'unset',
      textAlign: 'center',
      wordBreak: 'keep-all',
    },
    brandDescription: {
      fontSize: screenSize >= 768 ? 18 : 16,
      color: 'var(--dark-gray-color)',
      cursor: 'pointer',
    },
    emptyState: {
      textAlign: 'center',
      padding: 20,
      fontSize: 16,
      color: 'gray',
      width: '100%',
    },
    tapStyle: {
      width: screenSize >= 768 ? 100 : 80,
      height: screenSize >= 768 ? 48 : 40,
      borderRadius: 100,
      fontSize: screenSize >= 768 ? 16 : 14,
    },
  };

  /* ===== Hooks ===== */
  React.useEffect(() => {
    if (!brand.length) return;

    setBrandList([...brand]);
  }, [brand]);

  /* ===== Render ====== */
  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '120px 0px' : '80px 0'}
    >
      <Row gutter={25}>
        <Col x={0} md={1} lg={2}></Col>
        <Col x={24} md={20}>
          <Content maxWidth={'100%'} style={{ padding: '0 2px' }}>
            <Title
              align={'center'}
              style={{
                ...styles.title,
                marginBottom: screenSize >= 768 ? 120 : 60,
              }}
            >
              BRAND
            </Title>
            {/* <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: screenSize >= 768 ? 12 : 7,
                marginBottom: screenSize >= 768 ? 100 : 60,
                //padding: screenSize >= 768 ? 0 : '0 20px',
              }}
            >
              {TAP.map((tab) => (
                <Button
                  key={`tab-${tab.value}`}
                  style={{
                    ...styles.tapStyle,
                    ...(activeButton === tab.value
                      ? styles.activeButton
                      : styles.button),
                  }}
                  onClick={() => handleFilter(tab.value)}
                >
                  {tab.label}
                </Button>
              ))}
            </div> */}

            <Row
              gutter={[
                screenSize >= 768 ? 15 : 10,
                screenSize >= 768 ? 60 : 20,
              ]}
            >
              {' '}
              {brandList.length ? (
                brandList
                  .slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)
                  .map((brand) => (
                    <Col
                      key={`shop_${brand.shop_information_name}_${brand.shop_information_id}`}
                      md={12} // 768px 이상에서 2열
                      lg={6} // 1024px 이상에서 4열
                      style={styles.brandItem}
                      onClick={() =>
                        navigate(
                          `/brand/${encodeURIComponent(
                            encrypt(brand.shop_information_id)
                          )}`
                        )
                      }
                    >
                      <Image
                        src={brand?.thumbnail}
                        alt={`${brand?.shop_information_name}`}
                        style={styles.brandImage}
                      />
                      <Text style={styles.brandTitle}>
                        {brand.shop_information_name}
                      </Text>
                    </Col>
                  ))
              ) : (
                <Col x={24} style={styles.emptyState}>
                  <Empty description={'브랜드가 없습니다.'} />
                </Col>
              )}
            </Row>

            {/* 페이지네이션 */}
            <div style={{ marginTop: 100 }}>
              <Pagination
                total={brandList?.length}
                pageSize={PAGE_COUNT}
                current={currentPage} // 상태 동기화
                onChange={(e) => setCurrentPage(e)}
                showSizeChanger
                onShowSizeChange={(current, size) => {
                  setCurrentPage(1); // 페이지 크기 변경 시 페이지 초기화
                }}
                showPage={5}
                buttonStyle={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: '#999999',
                  background: 'none',
                  width: 28,
                  height: 28,
                }}
                isButton={true}
                activeStyle={{
                  color: `var(--black-color) !important`,
                  borderBottom: '2px solid #111111',
                }}
                hoverStyle={{
                  color: `var(--black-color) !important`,
                }}
                navStyle={{
                  border: '1px solid var(--black-color)',
                }}
                isLatestButton={true}
              />
            </div>
          </Content>
        </Col>
        <Col x={0} md={1} lg={2}></Col>
      </Row>
    </Content>
  );
};

export default BrandPresenter;
